import { BreadcrumbItem } from 'components/breadcrumb/breadcrumbModel';
import { TranslatedAttributeLabel } from 'pages/trading/TranslatedAttributeLabel';

export interface TrendDetailPageBreadcrumbProps {
  breadcrumbItem: BreadcrumbItem;
}

export function MarketshareBreadCrumb({ breadcrumbItem }: TrendDetailPageBreadcrumbProps) {
  const filters = breadcrumbItem.filters ?? [];

  const category = filters.find(f => f.attribute === 'prdCategory')?.values[0] as string;

  return (
    <div>
      <TranslatedAttributeLabel attributeCode="prdCategory" attributeValue={category ?? ''} />
    </div>
  );
}
